import '@Vendor/TextInput';

const TextInput = PIXI.TextInput;
TextInput.prototype.destroyBoxCache = () => {};
export { TextInput };
